import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthUser } from '../models/auth/AuthUser';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LocalStoreService } from './local-store.service';
import { AuthActions } from '../models/auth/AuthActions';
import { RolesEnum } from '../models/users/roles/enums/roles';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {
  public currentUserSubject: BehaviorSubject<AuthUser> = new BehaviorSubject<AuthUser>(null!);
  public authUser: any;

  viewsRoles = {
    '/admin/dashboard': [],
    '/admin/inbound': [RolesEnum.InboundOperations],
    '/admin/inbound/inboundNote': [RolesEnum.InboundNotesList],
    '/admin/inbound/inboundNote/details': [RolesEnum.InboundNotesDetails],
    '/admin/inbound/inboundNote/create-inbound': [RolesEnum.InboundNotesCreate],
    '/admin/inbound/asn': [RolesEnum.AdvanceShippingNoticesASNList],
    '/admin/inbound/asn/details': [RolesEnum.AdvanceShippingNoticesASNDetails],
    '/admin/inbound/asn/create-asn': [RolesEnum.AdvanceShippingNoticesASNCreate],
    '/admin/inbound/receipt': [RolesEnum.ReceiptsList],
    '/admin/inbound/receipt/details': [RolesEnum.ReceiptsDetails],
    '/admin/inbound/receipt/create-receipt': [RolesEnum.ReceiptsCreate],


    '/admin/human-capital': [RolesEnum.HumanCapital],
    '/admin/human-capital/team': [RolesEnum.TeamsList],
    '/admin/human-capital/team/details': [RolesEnum.TeamsDetails],
    '/admin/human-capital/team/create-team': [RolesEnum.TeamsCreate],
    '/admin/human-capital/team/edit-team': [RolesEnum.TeamsUpdate],
    '/admin/human-capital/training': [RolesEnum.TrainingList],

    '/admin/inventory': [RolesEnum.InventoryOperations],
    '/admin/inventory/reservation': [RolesEnum.ReservationsAllReservations],
    '/admin/inventory/reservation/details': [RolesEnum.ReservationsDetails],
    '/admin/inventory/reservation/create-reservation/Quick_Reservation': [RolesEnum.ReservationsCreateQuickReservation],
    '/admin/inventory/reservation/create-reservation/Long_term_Reservation': [RolesEnum.ReservationsCreateLongtermReservation],
    '/admin/inventory/reservation/create-reservation/Lot_Reservation': [RolesEnum.ReservationsCreateLotReservation],
    '/admin/inventory/cycle-count': [RolesEnum.CycleCountList],
    '/admin/inventory/cycle-count/details': [RolesEnum.CycleCountDetails],
    '/admin/inventory/cycle-count/create-cycle-count': [RolesEnum.CycleCountCreate],
    '/admin/inventory/cycle-count/edit-cycle-count': [RolesEnum.CycleCountCreate],
    '/admin/inventory/hold': [RolesEnum.InventoryHoldList],
    '/admin/inventory/stock': [RolesEnum.StockTransferList],
    '/admin/inventory/stock/stock-move': [RolesEnum.MoveStockList],
    '/admin/inventory/warehouse-transfer': [RolesEnum.WarehouseTransferList],
    '/admin/inventory/warehouse-transfer/details': [RolesEnum.WarehouseTransferDetails],
    '/admin/inventory/warehouse-transfer/create-warehouse-transfer': [RolesEnum.WarehouseTransferCreate],

    '/admin/outbound': [RolesEnum.OutboundOperations],
    '/admin/outbound/outboundNote': [RolesEnum.OutboundNotesList],
    '/admin/outbound/outboundNote/details': [RolesEnum.OutboundNotesDetails],
    '/admin/outbound/outboundNote/create-outbound': [RolesEnum.OutboundNotesCreate],
    '/admin/outbound/dispatchNote': [RolesEnum.DispatchNotesDNList],
    '/admin/outbound/dispatchNote/details': [RolesEnum.DispatchNotesDNDetails],
    '/admin/outbound/dispatchNote/create-dispatchNote': [RolesEnum.DispatchNotesDNCreate],
    '/admin/outbound/allocation': [RolesEnum.Allocations],
    '/admin/outbound/pick': [RolesEnum.PickListsList],

    '/admin/inventory-setup': [RolesEnum.SetupInventory],
    '/admin/inventory-setup/sku': [RolesEnum.SKUList],
    '/admin/inventory-setup/sku/details': [RolesEnum.SKUDetails],
    '/admin/inventory-setup/sku/create-sku': [RolesEnum.SKUCreate],
    '/admin/inventory-setup/sku/edit-sku': [RolesEnum.SKUUpdate],
    '/admin/inventory-setup/sku-group': [RolesEnum.SKUGroupList],
    '/admin/inventory-setup/sku-group/details': [RolesEnum.SKUGroupDetails],
    '/admin/inventory-setup/sku-group/create-sku-group': [RolesEnum.SKUGroupCreate],
    '/admin/inventory-setup/sku-group/edit-sku-group': [RolesEnum.SKUGroupUpdate],
    '/admin/inventory-setup/sku-class': [RolesEnum.SKUClassList],
    '/admin/inventory-setup/sku-class/details': [RolesEnum.SKUClassDetails],
    '/admin/inventory-setup/sku-class/create-sku-class': [RolesEnum.SKUClassCreate],
    '/admin/inventory-setup/sku-class/edit-sku-class': [RolesEnum.SKUClassUpdate],

    '/admin/inventory-setup/packs': [RolesEnum.PacksList],
    '/admin/inventory-setup/packs/details': [RolesEnum.PacksDetails],
    '/admin/inventory-setup/packs/create-packs': [RolesEnum.PacksCreate],
    '/admin/inventory-setup/packs/edit-packs': [RolesEnum.PacksUpdate],

    '/admin/inventory-setup/sku-type': [RolesEnum.SKUTypeList],
    '/admin/inventory-setup/sku-type/details': [RolesEnum.SKUTypeDetails],
    '/admin/inventory-setup/sku-type/create-sku-type': [RolesEnum.SKUTypeCreate],
    '/admin/inventory-setup/sku-type/edit-sku-type': [RolesEnum.SKUTypeUpdate],

    '/admin/inventory-setup/hazard': [RolesEnum.HazardList],
    '/admin/inventory-setup/hazard/details': [RolesEnum.HazardDetails],
    '/admin/inventory-setup/hazard/create-hazard': [RolesEnum.HazardCreate],
    '/admin/inventory-setup/hazard/edit-hazard': [RolesEnum.HazardUpdate],

    '/admin/facility-setup': [RolesEnum.SetupFacility],
    '/admin/facility-setup/site': [RolesEnum.SitesList],
    '/admin/facility-setup/site/details': [RolesEnum.SitesDetails],
    '/admin/facility-setup/site/create-site': [RolesEnum.SitesCreate],
    '/admin/facility-setup/site/edit-site': [RolesEnum.SitesUpdate],
    '/admin/facility-setup/gate': [RolesEnum.GateList],
    '/admin/facility-setup/gate/details': [RolesEnum.GateDetails],
    '/admin/facility-setup/gate/create-gate': [RolesEnum.GateCreate],
    '/admin/facility-setup/gate/edit-gate': [RolesEnum.GateUpdate],
    '/admin/facility-setup/warehouse': [RolesEnum.WarehousesList],
    '/admin/facility-setup/warehouse/details': [RolesEnum.WarehousesDetails],
    '/admin/facility-setup/warehouse/create-warehouse': [RolesEnum.WarehousesCreate],
    '/admin/facility-setup/warehouse/edit-warehouse': [RolesEnum.WarehousesUpdate],
    '/admin/facility-setup/area': [RolesEnum.AreasList],
    '/admin/facility-setup/area/details': [RolesEnum.AreasDetails],
    '/admin/facility-setup/area/create-area': [RolesEnum.AreasCreate],
    '/admin/facility-setup/area/edit-area': [RolesEnum.AreasUpdate],
    '/admin/facility-setup/dock': [RolesEnum.DocksList],
    '/admin/facility-setup/dock/details': [RolesEnum.DocksDetails],
    '/admin/facility-setup/dock/create-dock': [RolesEnum.DocksCreate],
    '/admin/facility-setup/dock/edit-dock': [RolesEnum.DocksUpdate],
    '/admin/facility-setup/location': [RolesEnum.LocationsList],
    '/admin/facility-setup/location/details': [RolesEnum.LocationsDetails],
    '/admin/facility-setup/location/create-location': [RolesEnum.LocationsCreate],
    '/admin/facility-setup/location/edit-location': [RolesEnum.LocationsUpdate],
    '/admin/facility-setup/zone': [RolesEnum.ZonesList],
    '/admin/facility-setup/zone/details': [RolesEnum.ZonesDetails],
    '/admin/facility-setup/zone/create-zone': [RolesEnum.ZonesCreate],
    '/admin/facility-setup/zone/edit-zone': [RolesEnum.ZonesUpdate],

    '/admin/task': [RolesEnum.MyTasksList],
    '/admin/task/details': [RolesEnum.TaskDetails],
    '/admin/task/load': [RolesEnum.MyTasksOpen],
    '/admin/task/offload': [RolesEnum.MyTasksOpen],
    '/admin/task/hold': [RolesEnum.MyTasksOpen],
    '/admin/task/ship': [RolesEnum.MyTasksOpen],
    '/admin/task/initiateReceipt': [RolesEnum.MyTasksOpen],
    '/admin/task/receive': [RolesEnum.MyTasksOpen],
    '/admin/task/mci': [RolesEnum.MyTasksOpen],
    '/admin/task/putaway': [RolesEnum.MyTasksOpen],
    '/admin/task/ppe': [RolesEnum.MyTasksOpen],
    '/admin/task/load-plan': [RolesEnum.MyTasksOpen],
    '/admin/task/pick': [RolesEnum.MyTasksOpen],

    '/admin/administration': [RolesEnum.Administration],
    '/admin/administration/role': [RolesEnum.UserRoleList],
    '/admin/administration/role/details': [RolesEnum.UserRoleDetails],
    '/admin/administration/role/create-role': [RolesEnum.UserRoleCreate],
    '/admin/administration/role/edit-role': [RolesEnum.UserRoleUpdate],

    '/admin/administration/users': [RolesEnum.UserManagementList],
    '/admin/administration/users/details': [RolesEnum.UserManagementDetails],
    '/admin/administration/users/create-user': [RolesEnum.UsersCreate],
    '/admin/administration/users/edit-user': [RolesEnum.UserManagementUpdate],

    '/admin/administration/business-partners': [RolesEnum.BusinessPartnersList],
    '/admin/administration/business-partners/details': [RolesEnum.BusinessPartnersDetails],
    '/admin/administration/business-partners/create-business-partner': [RolesEnum.BusinessPartnersCreate],
    '/admin/administration/business-partners/edit-business-partner': [RolesEnum.BusinessPartnersUpdate],

    '/admin/administration/lotmap': [RolesEnum.LotMapList],
    '/admin/administration/lotmap/details': [RolesEnum.LotMapDetails],
    '/admin/administration/lotmap/create-lotmap': [RolesEnum.LotMapCreate],
    '/admin/administration/lotmap/edit-lotmap': [RolesEnum.LotMapUpdate],

    '/admin/settings-setup': [RolesEnum.SetupSettings],
    '/admin/settings-setup/checklist': [RolesEnum.ChecklistList],
    '/admin/settings-setup/checklist/details': [RolesEnum.ChecklistDetails],
    '/admin/settings-setup/checklist/create-checklist': [RolesEnum.ChecklistCreate],
    '/admin/settings-setup/checklist/edit-checklist': [RolesEnum.ChecklistUpdate],
    '/admin/settings-setup/system-settings': [RolesEnum.SystemSettings],

    '/admin/administration/organizations': [RolesEnum.OrganizationsList],
    '/admin/administration/organizations/details': [RolesEnum.OrganizationsDetails],
    '/admin/administration/organizations/create-organization': [RolesEnum.OrganizationsCreate],
    '/admin/administration/organizations/edit-organization': [RolesEnum.OrganizationsUpdate],

    '/admin/administration/division': [RolesEnum.DivisionsList],
    '/admin/administration/division/details': [RolesEnum.DivisionsDetails],
    '/admin/administration/division/create-division': [RolesEnum.DivisionsCreate],
    '/admin/administration/division/edit-division': [RolesEnum.DivisionsUpdate],

    '/admin/administration/stockholder': [RolesEnum.StockholderList],
    '/admin/administration/stockholder/details': [RolesEnum.StockholderDetails],
    '/admin/administration/stockholder/create-stockholder': [RolesEnum.StockholderCreate],
    '/admin/administration/stockholder/edit-stockholder': [RolesEnum.StockholderUpdate],

    '/admin/business-insights': [RolesEnum.BusinessInsights],

    '/admin/incidentManagment':[RolesEnum.IncidentManagement],
    '/admin/incidentManagment/incidentType':[RolesEnum.IncidentType],
    '/admin/incidentManagment/incidentTypeList':[RolesEnum.IncidentTypeList],
    'admin/incidentManagment/incidentType/create-incident-type':[RolesEnum.IncidentMangagmentCreate],
    'admin/incidentManagment/incidentType/edit-incident-type':[RolesEnum.IncidentTypeUpdate],
    'admin/incidentManagment/incidentType/details':[RolesEnum.IncidentTypeDetails],
    'admin/workflowSetting':[RolesEnum.WorkflowSettingsList],
    
    //TODO:add correct permissions
    'admin/distribution-management':[RolesEnum.IncidentManagement],
    'admin/distribution-management/vehicle':[RolesEnum.IncidentManagement],

    '/admin/MyInbox':[RolesEnum.MyInbox],
    '/admin/MyInbox//details':[RolesEnum.MyInbox],

    '/reports': [RolesEnum.ReportList],
    '/my-reports': [RolesEnum.MyReportsList],
    ////////////////////
    '/login': [],
    '/admin/notAuthorized': [],
    '/admin/user-preferences': [],
    '/admin/business-insights/warehouse-productivity': [RolesEnum.WarehouseProductivityActivityCount],
    '/admin/business-insights/chemical-volume': [RolesEnum.ChemicalVolumeList],

    '/admin/gate-management': [],
    '/admin/gate-management/gate-security': [],
    '/admin/gate-management/gate-pass': [],
    '/admin/gate-management/gate-pass/create-gate-pass': [],
    'gate-pass/print': [RolesEnum.GatePassPrint],

    '/admin/myprofile': [],
    '/': [],
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    private store: LocalStoreService
  ) {
    const ls = this.store.getItem('authUser') as AuthUser;
    if (ls && ls.token) {
      this.currentUserSubject.next(ls);
    }

    window.addEventListener('storage', () => {
      // When local storage changes, dump the list to
      const authUser = this.store.getItem('authUser') as AuthUser;
      if (
        (this.currentUserValue && authUser && this.currentUserValue.token !== authUser.token) ||
        (this.currentUserValue && !authUser) ||
        (!this.currentUserValue && authUser)
      ) {
        location.reload();
      }
    });
  }

  public get currentUserValue(): AuthUser {
    return this.currentUserSubject.value;
  }

  canAccess(link: any, gard = false, actions = []) {
    let canAccess = false;
    if (this.currentUserValue) {
      for (const [key, value] of Object.entries(this.viewsRoles)) {
        if (!value.length && key === link) { canAccess = true; } // no role need
        // gard
        let gardPathAccess = false;
        if (gard) { gardPathAccess = link && key && ((link.includes(key) && !Object.entries(this.viewsRoles).some(item => item[0] === link)) || link === key); }
        // if(actions.length){
        //   gardPathAccess = value.includes(role.moduleName.trim() as never)
        // }
        if (!canAccess && (key === link || gardPathAccess)) { // link && key && link.includes(key)
          this.currentUserValue.user.userActionList.forEach((role: AuthActions) => {
            // console.log(value)
            if ((value.includes(role.moduleName.trim() as never) || value.includes(role.pageName.trim() as never) || value.includes(role.actionName.trim() as never)) && !canAccess) {
              canAccess = true;
            }
          });
        }
      }
    }
    return canAccess;
  }

  login(data: any) {
    return this.http.post<AuthUser>(
      `${environment.apiUsr}/Authentication/LoginUser`, data)
      .pipe(map(user => {
        if (user && user.token) {
          this.currentUserSubject.next(user);
          localStorage.setItem('authUser', JSON.stringify(user));
          return user;
        }
        return user;
      }));
  }

  logout() {
    this.clearUserData();
    this.router.navigate(['/login']).then(() => location.reload());
  }
  clearUserData() {
    localStorage.removeItem('authUser');
    localStorage.removeItem('fcmToken');
    this.currentUserSubject.next(null!);
  }

  createFmcToken(data: any) {
    return this.http.post(`${environment.apiUsr}/Authentication/CreateFmcToken`, data);
  }

  hasPermission(permission: string) {
    const accessControls: AuthActions[] = this.currentUserValue.user.userActionList!;
    const accessRolesList = permission.split(',');
    const founded = [];
    accessRolesList.forEach(role => {
      const found = accessControls.some(control => control.moduleName.trim() === role || control.pageName.trim() === role || control.actionName.trim() === role);
      if (found) { founded.push(role); }
    });
    if (founded.length) { return true; }
    else { return false; }
  }
}
